import { BaseFetch } from "../main-model"
export default class WithdrawBudgetModel extends BaseFetch {
  getWithdrawBudgetBy = (data) =>
    this.authFetch({
      url: "withdraw-budget/getWithdrawBudgetBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getWithdrawBudgetById = (data) =>
    this.authFetch({
      url: "withdraw-budget/getWithdrawBudgetById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateWithdrawBudgetById = (data) =>
    this.authFetch({
      url: "withdraw-budget/updateWithdrawBudgetById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertWithdrawBudget = (data) =>
    this.authFetch({
      url: "withdraw-budget/insertWithdrawBudget",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteWithdrawBudgetById = (data) =>
    this.authFetch({
      url: "withdraw-budget/deleteWithdrawBudgetById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
